
import React from 'react';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { CountryItem } from '../types';

interface CountryDialogFieldsProps {
  country: CountryItem;
  onCountryChange: (updatedCountry: CountryItem) => void;
}

export const CountryDialogFields = ({ country, onCountryChange }: CountryDialogFieldsProps) => {
  return (
    <div className="grid gap-4 py-4">
      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="name" className="text-right">Name</Label>
        <Input
          id="name"
          value={country.name}
          onChange={(e) => onCountryChange({ ...country, name: e.target.value })}
          className="col-span-3"
        />
      </div>
      
      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="code" className="text-right">Code</Label>
        <Input
          id="code"
          value={country.code}
          readOnly
          className="col-span-3 bg-gray-100"
        />
        <div className="col-span-4 text-sm text-gray-500 text-right">
          Country code cannot be changed
        </div>
      </div>

      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="status" className="text-right">Status</Label>
        <div className="flex items-center space-x-2 col-span-3">
          <Switch
            id="status"
            checked={country.active}
            onCheckedChange={(checked) => onCountryChange({ ...country, active: checked })}
          />
          <span>{country.active ? 'Active' : 'Inactive'}</span>
        </div>
      </div>
    </div>
  );
};
